import { render } from "./HdAlert.vue?vue&type=template&id=8f6a3a36"
import script from "./HdAlert.vue?vue&type=script&lang=js"
export * from "./HdAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__